// Copyright 2026, Imprivata, Inc.  All rights reserved.

import { useQuery } from '@tanstack/react-query';

import { getPasswordExpirationInfo } from '../../api/portalServices';
import type { PasswordExpirationInfoGetResponse } from '../../api/types';
import { QueryKey } from '../constants';

export const usePasswordExpirationInfo = () => {
  return useQuery<PasswordExpirationInfoGetResponse>({
    queryKey: [QueryKey.PASSWORD_EXPIRATION_INFO],
    queryFn: getPasswordExpirationInfo,
    staleTime: 0,
    refetchOnMount: 'always',
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });
};
